import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const LinkBuilding = () => {
  const pageData = {
    category: "LINK BUILDING",
    title: "Strategic Link Building Campaigns",
    description: "Earn high-quality, authoritative backlinks that boost rankings and drive referral traffic. Our white-hat link building strategies follow Google guidelines and deliver sustainable results.",
    ctaText: "Get a Free SEO Audit",
    ctaLink: "/contact",
    parentLink: "/services/seo",
    parentTitle: "SEO",

    features: [
      {"icon": "🎯", "title": "White-Hat Outreach", "description": "Ethical link acquisition strategies that comply with search engine guidelines."},
      {"icon": "📝", "title": "Niche Edits", "description": "Contextual backlinks placed in relevant existing content."},
      {"icon": "🔍", "title": "Broken Link Reclamation", "description": "Identify and replace broken links with your content."},
      {"icon": "🤝", "title": "Blog Collaborations", "description": "Partner with industry blogs for mutually beneficial content."},
      {"icon": "📈", "title": "Competitive Analysis", "description": "Analyze competitor backlink profiles to find opportunities."},
      {"icon": "🌐", "title": "Link Portfolio Diversity", "description": "Build a natural mix of link types, anchors, and sources."}
    ],

    benefits: [
      {
        title: "Higher Search Rankings",
        description: "Achieve top positions for your target keywords and dominate search results."
      },
      {
        title: "Increased Organic Traffic",
        description: "Drive more qualified visitors to your website without paying for ads."
      },
      {
        title: "Better User Experience",
        description: "Optimizations that benefit both search engines and your users."
      },
      {
        title: "Measurable ROI",
        description: "Track rankings, traffic, and conversions with detailed reporting."
      }
    ],

    process: [
      {
        title: "Audit & Analysis",
        description: "Comprehensive analysis of current performance and opportunities."
      },
      {
        title: "Strategy Development",
        description: "Custom roadmap tailored to your business goals and market."
      },
      {
        title: "Implementation",
        description: "Execute optimizations with precision and best practices."
      },
      {
        title: "Monitor & Refine",
        description: "Continuous tracking and optimization for maximum results."
      }
    ],

    whyChoose: {
      title: "Expert SEO Specialists",
      description: "Our team has years of experience delivering results across industries. We follow white-hat practices and stay updated with the latest algorithm changes.",
      points: [
        {
          title: "Proven Track Record",
          description: "300%+ average traffic increase for our clients"
        },
        {
          title: "Transparent Reporting",
          description: "Monthly reports with clear KPIs and actionable insights"
        },
        {
          title: "Dedicated Support",
          description: "Direct access to your SEO specialist and account manager"
        }
      ]
    },

    relatedServices: [
      {"icon": "🌐", "title": "Off-Page SEO", "description": "Broader authority building strategies", "link": "/services/seo/off-page"},
      {"icon": "📝", "title": "On-Page SEO", "description": "Content optimization for linkability", "link": "/services/seo/on-page"},
      {"icon": "⚙️", "title": "Technical SEO", "description": "Technical foundation for link value", "link": "/services/seo/technical-seo"}
    ]
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Link Building Services" 
                description="Learn more about our Link Building services to grow your business online with Digi Network." 
                canonical="/seo/link-building" 
            />

    </>
  );
};

export default LinkBuilding;
